import { writable } from "svelte/store";

export const flagContactReasonStore = writable({});

// Since the flagging goes via the CRM, it's slow so we maintain a
// list of flagged contacts locally which we remove by hand prior to
// display.
export const flaggedContacts = writable([]);
